import { useParams } from 'react-router-dom';
import ChatList from '../chat-list/ChatList';
import EditChatView from '../chat-list/EditChatView';
import BlankLayout from '../../../../materio/@core/layouts/BlankLayout';
import { ReactNode } from 'react';

const EditChatScreen = () => {
    const { chatId } = useParams();

    return (
        <EditChatView chatId={chatId!} />        
    )
}

EditChatScreen.guestGuard = false;
EditChatScreen.authGuard = true;
EditChatScreen.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>
export { EditChatScreen }

export default EditChatScreen;